import Layout from "./site/Layout";
import Home from "./site/pages/Home";
import Produits from "./site/pages/Produits";
import Protocole from "./site/pages/Protocole";
import APropos from "./site/pages/APropos";
import Contact from "./site/pages/Contact";
import Faq from "./site/pages/Faq";
import NotFound from "./site/pages/NotFound";

const PAGES = {
  "/": Home,
  "/produits/": Produits,
  "/protocole/": Protocole,
  "/a-propos/": APropos,
  "/contact/": Contact,
  "/faq/": Faq,
};

export function normalizePath(p) {
  if (!p) return "/";
  let path = p.split("?")[0].split("#")[0].toLowerCase();
  if (path !== "/" && !path.endsWith("/")) path += "/";
  return path;
}

export default function App({ path }) {
  const current = normalizePath(
    path || (typeof window !== "undefined" ? window.location.pathname : "/"),
  );
  const Page = PAGES[current] || NotFound;
  return (
    <Layout path={current}>
      <Page />
    </Layout>
  );
}
